// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sortSidebar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: auto;
  height: 70px;
  width: 100%;
  background: #1f2c3c;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 34px;
  padding: 0 24px;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.3);
  z-index: 60;
}

.sortOption,
.sortOption-selected {
  writing-mode: horizontal-tb;
  transform: none;
  font-family: 'Courier Prime', monospace;
  font-size: 14px;
  font-weight: 750;
  padding: 8px 14px;
  border-radius: 8px;
  transition: .3s;
}

.sortOption {
  color: rgba(199, 169, 169, 0.928);
  cursor: pointer;
}

.sortOption:hover {
  color: white;
  background-color: #34495e;
}

.sortOption-selected {
  color: white;
  background: #2c3e50;
}

.sortOption-selected:hover {
  background: #9bc5ef;
}

/* #infoContainer {
  position: fixed;
  top: var(--toolbar-height);
  left: var(--sidebar-width);
  width: var(--info-width);
  height: calc(100vh - var(--toolbar-height));
  padding:28px 26px 60px;
  overflow-y:auto;
  background: var(--clr-surface);
  border-right:1px solid var(--clr-border);
  -webkit-backdrop-filter: blur(28px) saturate(180%);
  backdrop-filter: blur(28px) saturate(180%);
} */

#infoContainer {
  position: fixed;
  top: 100px; /* same toolbar height */
  left: 0;
  width: calc(28vw + 20px);
  height: calc(100vh - 170px);
  background: var(--clr-surface);
  padding: 20px 28px 24px;
  border-left: 3px solid #e67e22;
  box-shadow: none;
  z-index: 10;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,eAAe;EACf,UAAU,EAAE,wBAAwB;EACpC,OAAO;EACP,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["#sortSidebar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: auto;\n  height: 70px;\n  width: 100%;\n  background: #1f2c3c;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 34px;\n  padding: 0 24px;\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.3);\n  z-index: 60;\n}\n\n.sortOption,\n.sortOption-selected {\n  writing-mode: horizontal-tb;\n  transform: none;\n  font-family: 'Courier Prime', monospace;\n  font-size: 14px;\n  font-weight: 750;\n  padding: 8px 14px;\n  border-radius: 8px;\n  transition: .3s;\n}\n\n.sortOption {\n  color: rgba(199, 169, 169, 0.928);\n  cursor: pointer;\n}\n\n.sortOption:hover {\n  color: white;\n  background-color: #34495e;\n}\n\n.sortOption-selected {\n  color: white;\n  background: #2c3e50;\n}\n\n.sortOption-selected:hover {\n  background: #9bc5ef;\n}\n\n/* #infoContainer {\n  position: fixed;\n  top: var(--toolbar-height);\n  left: var(--sidebar-width);\n  width: var(--info-width);\n  height: calc(100vh - var(--toolbar-height));\n  padding:28px 26px 60px;\n  overflow-y:auto;\n  background: var(--clr-surface);\n  border-right:1px solid var(--clr-border);\n  -webkit-backdrop-filter: blur(28px) saturate(180%);\n  backdrop-filter: blur(28px) saturate(180%);\n} */\n\n#infoContainer {\n  position: fixed;\n  top: 100px; /* same toolbar height */\n  left: 0;\n  width: calc(28vw + 20px);\n  height: calc(100vh - 170px);\n  background: var(--clr-surface);\n  padding: 20px 28px 24px;\n  border-left: 3px solid #e67e22;\n  box-shadow: none;\n  z-index: 10;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
